const factors = [
  {
    icon: 'ri-stack-line',
    title: 'Material',
    desc: 'O tipo de geomembrana (PEAD, PELBD, PVC, PP) determina a temperatura e o perfil de solda ideais. Cada material possui ponto de fusão e características de fluidez diferentes.',
  },
  {
    icon: 'ri-ruler-line',
    title: 'Espessura',
    desc: 'A espessura do material (medida em mic ou mm) impacta diretamente na potência necessária. Materiais mais espessos exigem máquinas com maior capacidade térmica.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Produtividade',
    desc: 'A velocidade de solda (m/min) define quantos metros lineares a máquina consegue soldar por minuto. Para grandes obras, priorize modelos de alta velocidade.',
  },
  {
    icon: 'ri-timer-line',
    title: 'Velocidade',
    desc: 'Relacionada à produtividade, a velocidade de avanço deve ser compatível com o cronograma da obra. Máquinas mais rápidas reduzem o tempo total de execução.',
  },
  {
    icon: 'ri-building-line',
    title: 'Tipo de Obra',
    desc: 'Obras de grande escala (aterros, barragens) exigem equipamentos robustos com alta produtividade. Obras menores e detalhes permitem máquinas mais compactas.',
  },
  {
    icon: 'ri-suitcase-line',
    title: 'Mobilidade',
    desc: 'O peso e as dimensões da máquina afetam o transporte e a operação em campo. Modelos compactos são ideais para locais de difícil acesso.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Tipo de Soldagem',
    desc: 'A soldagem pode ser por cunha quente (para sobreposição) ou por extrusão (para reparos e detalhes). Escolha conforme a técnica predominante na sua obra.',
  },
];

export default function HowToChoose() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-green-600 text-xs font-black uppercase tracking-[0.2em]">
            Guia de Compra
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 uppercase mt-3 mb-4">
            Como Escolher uma Máquina de Solda de Geomembrana?
          </h2>
          <p className="text-gray-500 text-sm max-w-2xl mx-auto leading-relaxed">
            A escolha do equipamento ideal depende de diversos fatores técnicos e operacionais. Conheça os principais critérios para tomar a melhor decisão.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {factors.map((factor) => (
            <div
              key={factor.title}
              className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-green-200 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-xl mb-4">
                <i className={`${factor.icon} text-green-600 text-lg`} />
              </div>
              <h3 className="text-sm font-black text-gray-900 uppercase mb-2">{factor.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{factor.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 bg-gray-900 rounded-2xl text-center">
          <p className="text-green-400 text-sm font-black uppercase tracking-wide mb-2">
            Não tem certeza de qual modelo escolher?
          </p>
          <p className="text-gray-300 text-xs max-w-lg mx-auto leading-relaxed">
            Cada obra possui características únicas. Nossa equipe analisa seu projeto e recomenda o equipamento mais adequado, sem compromisso.
          </p>
        </div>
      </div>
    </section>
  );
}